import styled from "styled-components";

// Fills the scrollable page container so the table can scroll internally
// while the filter bar stays visible (same sizing as the Pipelines list).
export const PageRoot = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;
